import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { TextField, PrimaryButton, Dropdown, MessageBar, MessageBarType, DefaultButton, Checkbox } from 'office-ui-fabric-react';
import moment from 'moment';
import _ from "lodash";

import { toggleModal } from 'app/redux/modal/actions';
import { IList, IListFilter, IListState, StatusEnum } from 'app/shared';
import { RootState } from "app/redux/reducer";
import { deleteRecovery, getRecoveries, updateRecovery } from 'app/services/recovery';
import { IActivityVariant, getActivityVariants, deleteActivityVariant, ActivityVariantStatus, publishActivityVariantByActivity, publishActivityVariant } from 'app/services/activity-variant';
import { IActivity } from 'app/services/activity';

import BasicTable from 'components/customs/BasicTable';
import { castThunkAction } from 'app/utils/casting';
import { toggleConfirmDialog } from 'app/redux/system/actions';
import DayPickerInput from "components/customs/DayPickerInput"

type OwnProps = {
    activityId: string
    activityTitle: string
    activityLanguage: string
}

function mapStateToProps(state: RootState, ownProps: OwnProps) {
    return {
        ...ownProps,
        language: state.system.language,
        pageData: state.page.pageData as IActivity,
        defaultLanguage: state.system.defaultLanguage
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return bindActionCreators({
        deleteActivityVariant,
        getActivityVariants,
        toggleConfirmDialog,
        publishActivityVariantByActivity,
        publishActivityVariant,
        toggleModal,
        getRecoveries,
        updateRecovery,
        deleteRecovery
    }, dispatch);
}

type IListActivityVariantProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

interface ListActivityVariantState extends IListState {
    data: IList<IActivityVariant[]>,
    selectedCheckboxes: string[]
}

class ListActivityVariant extends React.Component<IListActivityVariantProps, ListActivityVariantState> {
    state = {
        type: "activity-variant",
        filterObject: {
            title: "",
            status: 1,
            createdOn: "",
            date: "",
            activityId: this.props.activityId,
            language: this.props.activityLanguage || "tr"
        },
        pagerObject: {
            page: 1,
            descending: false,
            pageSize: 10
        },
        data: { list: [], totalCount: 0, pageCount: 0, pageSize: 0 } as IList<IActivityVariant[]>,
        selectedCheckboxes: [],
        activeStatus: StatusEnum.Published
    }

    UNSAFE_componentWillReceiveProps(nextProps: IListActivityVariantProps) {
        if (nextProps.activityLanguage !== this.props.activityLanguage) {
            this.setState({
                filterObject: {
                    ...this.state.filterObject,
                    language: nextProps.activityLanguage,
                    activityId: nextProps.activityId
                }
            }, () => this.searchList())
        }
    }

    componentDidMount() {
        this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })
    }

    makeRequest(options: IListFilter) {
        if (this.state.filterObject.status === StatusEnum.Deleted) {
            castThunkAction(this.props.getRecoveries(options, this.state.type))
                .then(() => {
                    this.setState({
                        activeStatus: StatusEnum.Deleted,
                    })
                })
        } else {
            castThunkAction<IList<IActivityVariant[]> | null>(this.props.getActivityVariants(options)).then((response) => {
                if (response) {
                    this.setState({
                        activeStatus: this.state.filterObject.status,
                        data: response
                    })
                }
            })
        }
    }

    searchList() {
        this.setState({
            pagerObject: {
                page: 1,
                descending: false,
                pageSize: 10
            },
        }, () => {
            this.makeRequest({
                ...this.state.pagerObject,
                ...this.state.filterObject
            })
        })
    }

    renderFilter() {
        return (
            <div className="table-filter row" style={{ marginBottom: this.state.data.list.length > 0 ? "0px" : "10px" }}>
                <TextField
                    className="custom-textfield col-md-2"
                    label="Başlık İle Arama"
                    value={this.state.filterObject?.title || ""}
                    onChange={(event: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "title": event.target.value
                            }
                        })
                    }}
                />
                <Dropdown
                    options={[
                        { key: StatusEnum.Published, text: "Yayında" },
                        { key: StatusEnum.Deleted, text: "Silinmiş" }
                    ]}
                    className="custom-dropdown col-md-2"
                    label="Duruma Göre Arama"
                    placeholder="Seçiniz"
                    selectedKey={this.state.filterObject?.status}
                    onChange={(event: any, option: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "status": option.key
                            }
                        })
                    }}
                    calloutProps={{
                        className: "custom-dropdown-callout"
                    }}
                />
                <DayPickerInput
                    onChange={(date: string) => this.setState({
                        filterObject: {
                            ...this.state.filterObject,
                            date
                        }
                    })}
                />
                <PrimaryButton
                    text="Arama Yap"
                    className="custom-button"
                    onClick={() => this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })}
                    styles={{
                        root: {
                            fontSize: "11px",
                            marginTop: "27px",
                            height: "37px"
                        }
                    }}
                />
            </div>
        )
    }

    renderList() {
        return (
            <React.Fragment>
                <BasicTable
                    hidePagerFromBottom={true}
                    totalCount={this.state.data.totalCount}
                    columns={[
                        {
                            columnName: "checkbox",
                            text: "#",
                            col: "col-md-1",
                            onRender: (item: IActivityVariant) => {
                                const selectedIndex = this.state.selectedCheckboxes.findIndex(id => id === item.id);

                                return (
                                    <Checkbox
                                        className="custom-checkbox"
                                        onChange={(ev, checked) => {
                                            const selectedItems: string[] = _.cloneDeep(this.state.selectedCheckboxes);

                                            if (!checked) {
                                                selectedItems.splice(selectedIndex, 1)
                                            }
                                            else {
                                                selectedItems.push(item.id as string)
                                            }

                                            this.setState({ selectedCheckboxes: selectedItems })
                                        }}
                                        checked={selectedIndex !== -1 ? true : false}
                                    />
                                )
                            }
                        },
                        {
                            columnName: "title",
                            text: "Seans Adı",
                            col: "col-md-2",
                            onRender: (item: IActivityVariant) => {
                                return (
                                    <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            this.props.toggleModal("activityVariant", item, (values) => {
                                                if (values) {
                                                    this.searchList()
                                                }
                                            })
                                        }}>
                                        {item.title}
                                    </span>
                                )
                            }
                        },
                        {
                            columnName: "startDate",
                            text: "Başlangıç Tarihi",
                            col: "col-md-2",
                            onRender: (item: IActivityVariant) => {
                                return moment(item.startDate).format("DD/MM/YYYY HH:mm")
                            }
                        },
                        {
                            columnName: "endDate",
                            text: "Bitiş Tarihi",
                            col: "col-md-2",
                            onRender: (item: IActivityVariant) => {
                                return item.endDate ? moment(item.endDate).format("DD/MM/YYYY HH:mm") : "-"
                            }
                        },
                        {
                            columnName: "publish",
                            text: "Web'de Gösterilsin Mi?",
                            col: "col-md-2",
                            onRender: (item: IActivityVariant) => {
                                if (item.publish) {
                                    return <span className="td-button" style={{ background: "#2b925f" }}>Göster</span>
                                } return <span className="td-button" style={{ background: "#ede0d6", color: "#a74d09" }}>Gizle</span>
                            }
                        },
                        {
                            columnName: "operations",
                            text: "İşlemler",
                            col: "col-md-3",
                            onRender: (item) => {
                                return (
                                    <>
                                        <div
                                            className="status-button active"
                                            onClick={() => {
                                                this.props.toggleConfirmDialog(true, {
                                                    callback: () => {
                                                        castThunkAction(this.props.deleteActivityVariant(item.id as string)).then(values => {
                                                            if (values) {
                                                                this.searchList()
                                                            }
                                                        })
                                                    }
                                                })
                                            }}
                                        >
                                            Sil
                                        </div>
                                        <div
                                            className="status-button"
                                            onClick={() =>
                                                this.props.toggleModal("activityVariant", item, (values) => {
                                                    if (values) {
                                                        this.searchList()
                                                    }
                                                })
                                            }
                                        >
                                            Düzenle
                                        </div>
                                    </>
                                );
                            }
                        },
                    ]}
                    items={this.state.data.list || []}
                    showPager={true}
                    pageCount={this.state.data.pageCount}
                    onChangePageSize={(pageSize) => {
                        this.setState({ pagerObject: { ...this.state.pagerObject, pageSize } }, () => this.makeRequest({
                            ...this.state.pagerObject,
                            ...this.state.filterObject,
                            pageSize
                        }))
                    }}
                    onChangePager={(pageNumber) => {
                        this.setState({ pagerObject: { ...this.state.pagerObject, page: pageNumber } }, () => this.makeRequest({
                            ...this.state.pagerObject,
                            ...this.state.filterObject,
                            page: pageNumber
                        }))
                    }}
                    pageIndex={this.state.pagerObject.page - 1}
                />
                {this.state.selectedCheckboxes.length ? (
                    <div className="activity-variant-selections">
                        <PrimaryButton
                            className="custom-button custom-button-green"
                            onClick={() => {
                                this.props.toggleConfirmDialog(true, {
                                    title: "Seçtiğiniz seanslar yayımlansın mı?",
                                    text: "Geçerli etkinliğe ait seçtiğiniz seansları yayımlamak istiyor musunuz? Eğer istiyorsanız 'Yayımla' butonuna basınız.",
                                    button: {
                                        approveText: "Yayımla"
                                    },
                                    callback: () => {
                                        castThunkAction(this.props.publishActivityVariant(this.state.selectedCheckboxes)).then(response => {
                                            this.setState({
                                                selectedCheckboxes: []
                                            }, () => {
                                                this.searchList()
                                            })
                                        })
                                    }
                                })
                            }}
                        >
                            Seçilen seansları yayımla
                        </PrimaryButton>
                    </div>
                ) : null}
                <div className="activity-variant-selections">
                    <PrimaryButton
                        className="custom-button"
                        onClick={() => {
                            this.props.toggleConfirmDialog(true, {
                                title: "Tüm seanslar yayımlansın mı?",
                                text: "Geçerli etkinliğe ait tüm seansları yayımlamak istiyor musunuz? Eğer istiyorsanız 'Tümünü yayımla' butonuna basınız.",
                                button: {
                                    approveText: "Tümünü yayımla"
                                },
                                callback: () => {
                                    castThunkAction(this.props.publishActivityVariantByActivity(this.props.pageData.id as string)).then(response => {
                                        this.searchList()
                                    })
                                }
                            })
                        }}
                    >
                        Tümünü yayımla
                    </PrimaryButton>
                </div>
            </React.Fragment>
        )
    }

    render() {
        return (
            <div className="form-wrapper row">
                <MessageBar
                    messageBarType={MessageBarType.info}
                    isMultiline={false}
                    actions={
                        <div>
                            <DefaultButton
                                className="custom-button"
                                text="Yeni Seans Ekle"
                                iconProps={{ iconName: "Add", style: { fontSize: 12 } }}
                                onClick={() => this.props.toggleModal(
                                    "activityVariant",
                                    {
                                        activityId: this.props.activityId,
                                        variantStatus: ActivityVariantStatus.Published,
                                        title: this.props.activityTitle,
                                        adminTitle: this.props.activityTitle,
                                        endDate: undefined,
                                        publish: false,
                                        order: 0,
                                        artists: [],
                                        language: this.props.pageData.language || "tr"
                                    },
                                    (values) => {
                                        if (values) {
                                            this.searchList()
                                        }
                                    }
                                )}
                            />
                        </div>
                    }
                    className="form-wrapper-message"
                >
                    Aşağıdan geçerli etkinliğe ait tüm seansları görüntüleyebilirsiniz. Dilerseniz seans düzenleyebilir veya yeni seans ekleyebilirsiniz.
                </MessageBar>
                {this.renderFilter()}
                {this.renderList()}
            </div>

        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListActivityVariant);